import fr from 'facet-rest';
import { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';

export const onExit = async (resource, onLoad, logStandardizedEvent, history) => {
  logStandardizedEvent(categories.addAccounts, eventTypes.selectInstitution, eventSubTypes.exiting);
  resource.withRelationship(fr.relationships.redirectOnExit.name,
    async (rel) => onLoad(rel.link('related')),
    () => history.push('/'));
};
